module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AaDAXD/tc-custom/9781526734365.jpg?1729082652078",
      "alt": "This image is the cover for the book Japan Triumphant, Images of War"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Japan Triumphant, Images of War\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Imperial Japan’s ambitious offensive at the beginning of WWII is captured in dramatic detail in this pictorial history featuring rare wartime photographs.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The Japanese offensive in the Far East in 1941-1942 was extraordinary in its ambition, for their aim was to advance across the entire region. They clashed with an array of forces in a series of lightning campaigns that included famous episodes like the raid on Pearl Harbor and the conquest of Singapore. In this vivid photographic history, historian Philip Jowett covers the whole course of the offensive, portraying not only the Japanese military which achieved such incredible success but the armies they overwhelmed."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In a sequence of over 200 wartime photographs—many of which have never been published before—Jowett covers the land, sea, and air fighting as the Japanese occupied so much of the region. Rare images of the Japanese forces as they prepared for war and then made seemingly unstoppable progress are matched with images of the armies they surprised and vanquished. "), _c('i', [_vm._v("Japan Triumphant")]), _vm._v(" captures the character of the war in the Far East, showing the appearance, equipment, and weaponry of the armies involved as well as the conditions in which they fought.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Philip Jowett\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword/Pen and Sword Military\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0